import {CoinsBannerSection_CoinsInfoSheet} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {
  AboutYouSVGLogo,
  COLORS,
  ContentPopper,
  ContentPopperProps,
  DrawerContainer,
  SecondaryContentPopperButton,
  Text,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useCoinsBannerStateManager} from '../utils/useCoinsBannerStateManager';
import {CoinsBannerPopupInfoSheet} from './CoinsBannerPopupInfoSheet';

export const CoinsBannerPopup: React.FC<
  CoinsBannerSection_CoinsInfoSheet & {
    LayoutComponent: ContentPopperProps['LayoutComponent'];
  }
> = ({LayoutComponent, title, headline, infoText, featureInfos, ctaText}) => {
  const {isOpen, cancel} = useCoinsBannerStateManager();

  return (
    <StyledContentPopper
      data-testid="coinsBannerPopup"
      LayoutComponent={LayoutComponent}
      onClose={cancel}
      open={isOpen}
      slideDirection="left"
      renderInPortal
      headerContent={
        <HeaderLogo>
          <StyledAboutYouSVGLogo disableLogoLink />
          <Text size="px24" weight="heavy">
            {title}
          </Text>
        </HeaderLogo>
      }
      bodyContent={
        <BodyContent>
          <CoinsBannerPopupInfoSheet
            headline={headline}
            infoText={infoText}
            featureInfos={featureInfos}
          />
        </BodyContent>
      }
      footerContent={
        <SecondaryContentPopperButton
          data-testid="coinsBannerPopupCta"
          label={ctaText}
          onClick={cancel}
        />
      }
    />
  );
};

const StyledContentPopper = styled(ContentPopper)`
  ${tabletAndUpLinaria(`max-width: 375px;`)}

  ${DrawerContainer} {
    ${tabletAndUpLinaria(`width: 100%;`)}
  }
`;

const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.White};
  height: 100%;
`;

const HeaderLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  flex: 1;
  padding: 10px 0 6px 0;

  ${tabletAndUpLinaria(`
    justify-content: flex-start;
    padding: 0 16px;
  `)}
`;

const StyledAboutYouSVGLogo = styled(AboutYouSVGLogo)`
  > svg {
    width: 121px;
    height: 24px;
  }
`;
